<template>
  <section class="h_12">
    <m-img src="@/v2/mobile/assets/image/h_12.jpg"></m-img>
  </section>
</template>

<script>
export default {}
</script>
<style lang="less" scoped>
.h_12 {
  margin-top: -5px;
}
</style>
